import { c as createFragmentDataLake } from "./dataLake.js";
import { u as useFragment } from "./fragment.js";
import { c as concatId } from "./helpers.js";
function useFederationFragmentsManager(options) {
  const fragments = /* @__PURE__ */ new Map();
  return {
    createFragment
  };
  function createFragment(createOptions) {
    if (!fragments.has(createOptions.name)) {
      fragments.set(createOptions.name, createFragmentService(createOptions));
    }
    return fragments.get(createOptions.name);
  }
  function createFragmentService(fragmentOptions) {
    const fragmentName = fragmentOptions.name;
    const networkService = options.networkService.getFragmentNetwork(fragmentName);
    const federationLocalization = options.federationLocalizationRoot.getFederationLocalization(fragmentName);
    const storage = options.rootStorages.create(fragmentName);
    const internalInjector = fragmentOptions.injector.__internal;
    const dataLake = createFragmentDataLake(options.versions, fragmentOptions);
    fragmentOptions.injector.provide("storage", storage);
    fragmentOptions.injector.provide("requester", fragmentOptions.requester.fork());
    fragmentOptions.injector.provide("localization", federationLocalization.fragmentLocalization);
    fragmentOptions.injector.provide("fragmentInfo", getFragmentInfo());
    fragmentOptions.injector.provide("dataLake", dataLake);
    internalInjector.provide("subfragmentsFabric", createSubfragmentsManager());
    return useFragment({
      networkService,
      federationLocalization,
      rootStorages: options.rootStorages,
      processException: options.processException,
      ...fragmentOptions
    });
    function getFragmentInfo() {
      const parent = internalInjector.inject("componentInfo", { defaultValue: void 0 });
      return { id: concatId(`${(parent == null ? void 0 : parent.id) ?? "root"}`, fragmentName), fragmentName };
    }
  }
  function createSubfragmentsManager() {
    const subfragments = /* @__PURE__ */ new Map();
    return {
      createSubfragmentsService
    };
    function createSubfragmentsService({ injector }) {
      return {
        createFragment: createSubfragment
      };
      function createSubfragment(remote) {
        if (!subfragments.has(remote.name)) {
          const subfragmentInjector = injector.__internal.fork();
          const subfragment = createFragmentService({
            name: remote.name,
            injector: subfragmentInjector,
            requester: subfragmentInjector.inject("requester")
          });
          subfragments.set(remote.name, subfragment);
        }
        return subfragments.get(remote.name);
      }
    }
  }
}
export {
  useFederationFragmentsManager as u
};
//# sourceMappingURL=fragmentsManager.js.map
